import { render, staticRenderFns } from "./budget-requests.vue?vue&type=template&id=a9f570dc&scoped=true&"
import script from "./budget-requests.vue?vue&type=script&lang=js&"
export * from "./budget-requests.vue?vue&type=script&lang=js&"
import style0 from "./budget-requests.vue?vue&type=style&index=0&id=a9f570dc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9f570dc",
  null
  
)

export default component.exports